module.exports = __webpack_public_path__ + "static/media/black_forest.ccb14020.jpg";